import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingUpIcon, CalendarIcon, CloudIcon, UsersIcon, RefreshCwIcon } from 'lucide-react';
const categories = ['All', 'Trending', 'Seasonal', 'Local Events', 'Competitors', 'Weather-Based'];
const mockIdeas = [{
  id: 1,
  title: 'Pumpkin Spice Season Launch',
  category: 'Seasonal',
  caption: 'Fall is here! ☕🍂 Try our new Pumpkin Spice Latte made with real pumpkin and organic spices. Tag a friend who needs this cozy treat!',
  hashtags: '#PumpkinSpice #FallVibes #CoffeeLover #LocalCafe',
  engagement: 'High',
  visual: 'Warm autumn colors, latte art with pumpkin design'
}, {
  id: 2,
  title: 'Street Food Festival Promo',
  category: 'Local Events',
  caption: 'See you at the Downtown Street Food Festival this Saturday! 🎉 Stop by our booth for exclusive festival specials and free samples.',
  hashtags: '#StreetFood #LocalEvent #Community #FoodFestival',
  engagement: 'High',
  visual: 'Festival booth setup, crowd engagement'
}, {
  id: 3,
  title: 'Sunny Weekend Special',
  category: 'Weather-Based',
  caption: 'Perfect weather for our outdoor patio! ☀️ Join us this weekend for 20% off all iced drinks. Bring your friends and soak up the sun!',
  hashtags: '#WeekendVibes #SunnyDays #PatioSeason #LocalCafe',
  engagement: 'Medium',
  visual: 'Outdoor seating, sunny ambiance and iced drinks.'
}, {
  id: 4,
  title: 'Behind-the-Scenes Roasting',
  category: 'Trending',
  caption: 'Ever wondered how we roast our signature blend? Watch our master roaster in action! Small-batch, locally sourced, perfectly crafted.',
  hashtags: '#BehindTheScenes #CoffeeRoasting #Artisan #CraftCoffee',
  engagement: 'High',
  visual: 'Coffee roasting process, artisan at work'
}, {
  id: 5,
  title: 'Customer Love Story',
  category: 'Trending',
  caption: 'Meet Sarah & Mike - they had their first date here 5 years ago and just got engaged! 💕 We love being part of your special moments.',
  hashtags: '#CustomerLove #LoveStory #LocalBusiness #Community',
  engagement: 'Medium',
  visual: 'Happy couple, heartwarming moment'
}, {
  id: 6,
  title: 'Competitor Response',
  category: 'Competitors',
  caption: "We noticed everyone', s, talking about seasonal drinks, Here', s why ours are different: locally sourced ingredients, handcrafted recipes and made with love : locally sourced ingredients, handcrafted recipes, and made with love ❤️️",
  hashtags: '#LocalFirst #Handcrafted #QualityMatters #SupportLocal',
  engagement: 'Medium',
  visual: 'Ingredient showcase, quality focus'
}];
export function ContentIdeasPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [isRefreshing, setIsRefreshing] = useState(false);
  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 1000);
  };
  const filteredIdeas = selectedCategory === 'All' ? mockIdeas : mockIdeas.filter(idea => idea.category === selectedCategory);
  return <div className="p-6 space-y-6" data-id="element-91">
      <div className="flex items-center justify-between" data-id="element-92">
        <div data-id="element-93">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white" data-id="element-94">
            Content Ideas
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1" data-id="element-95">
            AI-powered post ideas tailored for your local audience
          </p>
        </div>
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={handleRefresh} className="px-6 py-3 rounded-xl bg-purple-600 text-white font-semibold flex items-center gap-2" data-id="element-96">
          <RefreshCwIcon className={`w-5 h-5 ${isRefreshing ? 'animate-spin' : ''}`} data-id="element-97" />
          Refresh Ideas
        </motion.button>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2" data-id="element-98">
        {categories.map(cat => <button key={cat} onClick={() => setSelectedCategory(cat)} className={`px-4 py-2 rounded-xl font-medium whitespace-nowrap transition-all ${selectedCategory === cat ? 'bg-purple-600 text-white' : 'bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-800 hover:border-purple-300 dark:hover:border-purple-700'}`} data-id="element-99">
            {cat}
          </button>)}
      </div>
      <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-100">
        {filteredIdeas.map((idea, idx) => <motion.div key={idea.id} layout initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: idx * 0.05
      }} whileHover={{
        y: -8
      }} className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-lg hover:shadow-xl transition-all overflow-hidden group" data-id="element-101">
            <div className="h-48 bg-gradient-to-br from-purple-400 via-pink-400 to-orange-400 relative" data-id="element-102">
              <div className="absolute inset-0 bg-black/20 flex items-center justify-center" data-id="element-103">
                <p className="text-white text-sm font-medium px-4 text-center" data-id="element-104">
                  {idea.visual}
                </p>
              </div>
              <span className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${idea.engagement === 'High' ? 'bg-green-500 text-white' : 'bg-yellow-500 text-white'}`} data-id="element-105">
                {idea.engagement} Engagement
              </span>
            </div>
            <div className="p-5" data-id="element-106">
              <div className="flex items-center gap-2 mb-3" data-id="element-107">
                <span className="px-2 py-1 rounded-lg bg-purple-100 dark:bg-purple-900/20 text-purple-700 dark:text-purple-400 text-xs font-medium" data-id="element-108">
                  {idea.category}
                </span>
              </div>
              <h3 className="font-bold text-gray-900 dark:text-white mb-2" data-id="element-109">
                {idea.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-3" data-id="element-110">
                {idea.caption}
              </p>
              <p className="text-xs text-purple-600 dark:text-purple-400 mb-4" data-id="element-111">
                {idea.hashtags}
              </p>
              <div className="flex gap-2" data-id="element-112">
                <button className="flex-1 px-4 py-2 rounded-xl bg-purple-600 text-white text-sm font-medium hover:bg-purple-700 transition-colors" data-id="element-113">
                  Use This Idea
                </button>
                <button className="px-4 py-2 rounded-xl border border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-300 text-sm font-medium hover:border-purple-300 dark:hover:border-purple-700 transition-colors" data-id="element-114">
                  Variations
                </button>
              </div>
            </div>
          </motion.div>)}
      </motion.div>
    </div>;
}